/* Tiny Tag Shop — global.js
   Everything the whole site needs, in one small file. No framework, no
   dependencies. Loaded with `defer`. Every behaviour here is a progressive
   enhancement: the page works without it. */

(function () {
  'use strict';

  /* ---- Mobile navigation ------------------------------------------------ */
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.getElementById('mobile-nav');

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        toggle.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
        toggle.focus();
      }
    });
  }

  /* ---- Quantity steppers ------------------------------------------------
     The number input is the source of truth; the buttons just nudge it and
     fire `change` so Shopify's cart form picks the value up. */
  document.querySelectorAll('[data-quantity]').forEach(function (widget) {
    var input = widget.querySelector('input');
    if (!input) return;

    widget.querySelectorAll('button[data-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var step = Number(button.dataset.step);
        var min = Number(input.min || 0);
        var max = input.max ? Number(input.max) : Infinity;
        var next = Math.min(max, Math.max(min, Number(input.value || 0) + step));
        if (next === Number(input.value)) return;
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---- Cart line quantity + remove --------------------------------------
     Submits the cart form on change so no-JS visitors keep the visible
     "Update cart" button and JS visitors never have to press it. */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.addEventListener('change', function (event) {
      if (event.target.matches('[data-cart-quantity]')) cartForm.submit();
    });
  }

  /* ---- Collection facets ------------------------------------------------
     The filter form works as a plain GET form. With JS we submit on change
     and hide the manual button, so filtering feels instant on a phone. */
  var facetForm = document.querySelector('[data-facet-form]');
  if (facetForm) {
    var applyButton = facetForm.querySelector('[data-facet-apply]');
    if (applyButton) applyButton.classList.add('hidden');

    facetForm.addEventListener('change', function (event) {
      if (event.target.matches('input[type="checkbox"], select')) facetForm.submit();
    });
  }

  /* ---- Address delete ---------------------------------------------------
     The link Shopify gives us needs a DELETE, and deleting an address should
     ask first. Without JS the link is inert rather than destructive. */
  document.querySelectorAll('[data-confirm-delete]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      if (!window.confirm('Delete this address?')) return;

      var form = document.createElement('form');
      form.method = 'post';
      form.action = link.getAttribute('href');
      form.innerHTML = '<input type="hidden" name="_method" value="delete">';
      document.body.appendChild(form);
      form.submit();
    });
  });

  /* ---- Product gallery --------------------------------------------------
     Thumbnails swap the main image. Full-size sources come from the markup,
     so nothing extra is fetched until a thumbnail is pressed. */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    if (!main) return;

    gallery.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb) return;

      main.src = thumb.dataset.full;
      main.srcset = thumb.dataset.fullSrcset || '';
      main.alt = thumb.dataset.alt || '';
      main.removeAttribute('loading');

      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (other) {
        other.setAttribute('aria-current', String(other === thumb));
      });
    });
  });
})();
